(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("core-next-validation", [], factory);
	else if(typeof exports === 'object')
		exports["core-next-validation"] = factory();
	else
		root["core-next-validation"] = factory();
})(this, function() {
return 